export default "__VITE_ASSET__DhAAwmFf__"